export enum UserRole {
  SITE_MANAGER = 1,
  FLOOR_REPRESENTATIVE = 2,
  ADMINISTRATOR = 3,
  PROPERTY_MANAGER = 4,
}

export type Capability =
  | "reports.view"
  | "reports.download"
  | "buildings.manage"
  | "property_managers.manage"
  | "tenants.manage";

export type RoleName =
  | "site_manager"
  | "floor_representative"
  | "administrator"
  | "property_manager";
